import { render, staticRenderFns } from "./clientProfileWorkflowForms.vue?vue&type=template&id=723eb5d6&scoped=true"
import script from "./clientProfileWorkflowForms.vue?vue&type=script&lang=js"
export * from "./clientProfileWorkflowForms.vue?vue&type=script&lang=js"
import style0 from "./clientProfileWorkflowForms.vue?vue&type=style&index=0&id=723eb5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723eb5d6",
  null
  
)

export default component.exports